import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import './list-skeleton.scss';

interface ListSkeletonProps {
  height?: number;
  className?: string;
  length?: number;
}

export const ListSkeleton: React.FC<ListSkeletonProps> = ({
  height = 100,
  className = '',
  length = 8,
}) => {
  return (
    <div className={`list-skeleton ${className}`}>
      {[...Array(length)].map((_, idx) => (
        <Skeleton
          key={idx}
          animation="wave"
          variant="rounded"
          height={height}
          width={'100%'}
          style={{ borderRadius: 8 }}
          sx={{ bgcolor: '#d8d8d8' }}
        />
      ))}
    </div>
  );
};
